<template>
<span class="odr-toggle">
    <slot></slot>
</span>
</template>

<script>
import '../styles/toggle.scss'

export default {
    props: {
        use: {},
        defaultName: {
            default: 'true',
        },
        opened: {
            _descr: 'name of opened toggle-content by default',
        },
        keepOpenedRest: {
            _descr: 'hide rest toggle-content when specific was opened',
        },
    },
    data () {
        let store = this.use || {}

        if (this.opened) {
            store[this.opened] = true
        }
        return {
            purpose: 'for-toggle-node',
            store,
        }
    },
}
</script>
